export default __webpack_public_path__ + "static/media/slide2.7763bb41.jpg";